export const getHarvestFractionInfo = ({
  harvestFraction
}: {
  harvestFraction: string | undefined;
}) => {
  if (harvestFraction === undefined) {
    return undefined;
  }

  const FULL_SCALE = BigInt(18446744073709551616); // 2^64

  const fractionBigInt = BigInt(harvestFraction);
  const percentageHarvested =
    (Number(fractionBigInt) / Number(FULL_SCALE)) * 100;

  return Math.round(percentageHarvested);
};

export const determineAutoStatuses = ({
  harvestFraction
}: {
  harvestFraction: string | undefined;
}) => {
  const percentageHarvested = getHarvestFractionInfo({ harvestFraction });

  if (percentageHarvested === undefined) {
    return { isAutoHarvesting: false, isAutoCompounding: false };
  }

  const isAutoHarvesting = percentageHarvested > 0;
  const isAutoCompounding = percentageHarvested < 100;

  return { isAutoHarvesting, isAutoCompounding };
};
